export default __webpack_public_path__ + "static/media/restorePage.2d5835f6.svg";